// extracted by mini-css-extract-plugin
module.exports = {"content":"AddDialog_content__3Vap_","select":"AddDialog_select__13Ybr"};